import React from 'react';
import AppShell from '../../components/app-shell/app-shell';  
import PublicShell from '../../components/app-shell/public-shell';
import PublicMarkdown from '../../components/markdown/public-markdown';
import markdown from './contact.md';

export default function() {
  return (
    <AppShell
      seoTitle="Contact"
      description="We take customer service seriously. We're committed to your calligraphy success and would love to help you troubleshoot any problems or questions that you have."
    >
      <PublicShell>
        <PublicMarkdown markdown={markdown} />
      </PublicShell>
    </AppShell>
  );
}
